export function formatDate(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (isNaN(d)) return value;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}/${mm}/${d.getFullYear()}`;
}

const MONTHS = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet",
  "août", "septembre", "octobre", "novembre", "décembre"];

export function formatDateLong(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (isNaN(d)) return value;
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

export function euro(n) {
  const v = Number(n || 0);
  return `${v.toLocaleString("fr-FR")} €`;
}

export function daysUntil(value) {
  if (!value) return null;
  const d = new Date(value);
  if (isNaN(d)) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  d.setHours(0, 0, 0, 0);
  return Math.round((d - today) / 86400000);
}

export function progressBarClass(pct) {
  if (pct >= 90) return "bg-rose-600";
  if (pct >= 70) return "bg-orange-500";
  return "bg-emerald-500";
}

export function eventUrgency(startDate) {
  const d = daysUntil(startDate);
  if (d === null) return { label: "—", cls: "bg-slate-100 text-slate-600 border-slate-200" };
  if (d < 0) return { label: "Passé", cls: "bg-slate-100 text-slate-500 border-slate-200" };
  if (d === 0) return { label: "Aujourd'hui", cls: "bg-rose-100 text-rose-800 border-rose-300" };
  if (d <= 7) return { label: `J-${d}`, cls: "bg-rose-100 text-rose-800 border-rose-300" };
  if (d <= 30) return { label: `J-${d}`, cls: "bg-amber-100 text-amber-800 border-amber-300" };
  return { label: `J-${d}`, cls: "bg-slate-100 text-slate-600 border-slate-200" };
}

export function taskUrgency(deadline) {
  const d = daysUntil(deadline);
  if (d === null) return null;
  if (d < 0) return { label: `${Math.abs(d)}j de retard`, cls: "bg-rose-100 text-rose-700 border-rose-300" };
  if (d === 0) return { label: "Aujourd'hui", cls: "bg-rose-100 text-rose-700 border-rose-300" };
  if (d === 1) return { label: "Demain", cls: "bg-amber-100 text-amber-700 border-amber-300" };
  if (d <= 7) return { label: `${d}j`, cls: "bg-amber-100 text-amber-700 border-amber-300" };
  return { label: `${d}j`, cls: "bg-slate-100 text-slate-600 border-slate-200" };
}

export const PRIORITY_DOT = { high: "bg-rose-500", medium: "bg-amber-500", low: "bg-blue-500" };
export const CHART_COLORS = ["#8b5cf6", "#10b981", "#3b82f6", "#f59e0b", "#ec4899", "#6366f1", "#14b8a6"];
